import React from 'react'
import { RouteProps } from 'routes/AppRouter'
import { UsersNewsEditor } from 'features/users-new/Editor'
import { useTitleHeaderContext } from 'common/utils/TitleHeaderContext'
import logoCareme from 'assets/caremePlusLogo.svg'
import style from '../layout/Main.module.css'
import { Box } from '@mui/material'
import { useLocation, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export interface CreateEditParticipantProps extends RouteProps {
  isProfessional?: boolean
}

export function EditParticipant(props: RouteProps) {
  const { t } = useTranslation()
  let title = props.title || ''
  const { setTitle } = useTitleHeaderContext()
  const { id } = useParams()
  const location = useLocation()
  const { isProfessional } = location.state || { isProfessional: false }
  title = isProfessional ? (id ? t('editProfessional') : t('addProfessional')) : props.title || ''
  setTitle(title)

  return (
    <>
      <UsersNewsEditor id={id} isProfessional={isProfessional} />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
